import { manaSymbols } from "@/lib/mtg";
import { ManaSymbol } from "@/components/common/ManaSymbol";

export function ManaCost({ cost, size = "sm" }) {
  const symbols = manaSymbols(cost);
  if (!symbols.length) return null;
  return (
    <span className="inline-flex flex-wrap items-center gap-0.5" aria-label={`Mana cost ${cost}`} data-testid="mana-cost">
      {symbols.map((s, i) => <ManaSymbol key={i} sym={s} size={size === "lg" ? 24 : 18} className="drop-shadow" />)}
    </span>
  );
}
